import React from 'react';

const NavDropdown = ({ title, children }) => {
    return (
        <div className="relative group">
            <button className="inline-flex items-center space-x-1 px-3 py-2 text-sm font-medium rounded-lg transition-colors duration-200 text-gray-700 hover:text-blue-600 hover:bg-blue-50 whitespace-nowrap">
                <span>{title}</span>
                <svg className="w-4 h-4 ml-1" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 9l-7 7-7-7"></path>
                </svg>
            </button>
            <div className="absolute top-full left-0 mt-2 w-56 bg-white rounded-lg shadow-lg border border-gray-200 opacity-0 invisible group-hover:opacity-100 group-hover:visible transition-all duration-200 z-50">
                <div className="py-2">{children}</div>
            </div>
        </div>
    );
};

export default NavDropdown;
